import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { ICity, IDropdown } from "../../models/BaseModel";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { JVDropdown } from "../../shared/JVDropdown";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import LocationAutocomplete, { NominatimResponse } from "../../shared/LocationAutoCompleteGM";

const schema = yup.object({
    name: yup.string().required("City Name Type is required"),
    countryId: yup.number().required("Country is required").min(1, "Country is required"),
    stateId: yup.number().required("State is required").min(1, "State is required"),
});

interface Iprops {
    singleData: ICity,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Form = (props: Iprops) => {
    const [countries, setCountries] = useState<IDropdown[]>();
    const [states, setStates] = useState<IDropdown[]>();
    const [submitting, setSubmitting] = useState(false);
    const [description, setDescription] = useState("");

    const { control, handleSubmit, watch, formState: { errors }, reset, setValue } = useForm<ICity>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false,
    });

    const lat = watch('latitude');
    const lng = watch('longitude');

    const countryId = watch("countryId");

    useEffect(() => {
        loadCountries();
    }, []);
    useEffect(() => {
        if (countryId) loadStates(countryId);
    }, [countryId]);

    useEffect(() => {
        reset(props.singleData);
        setDescription(props.singleData.description ?? "")
    }, [props.singleData]);

    const loadCountries = async () => {
        const response = await Fetch("country/dropdown", "GET", null, null, null);
        if (response) {
            setCountries(await response.json());
        }
    }

    const loadStates = async (countryId: number) => {
        const response = await Fetch(`state/dropdown/${countryId}`, "GET", null, null, null);
        if (response) {
            setStates(await response.json());
        }
    }

    const saveToDB = async (body: ICity) => {
        body.description = description
        setSubmitting(true);
        const method = props.singleData.id ? "PUT" : "POST";
        const message = props.singleData.id ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch(`city${props.singleData.id ? '/' + props.singleData.id : ''}`, method, body, null, props.toast);
        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadData();
        }
        setSubmitting(false);
    }


    const onLocationSelect = (location?: NominatimResponse) => {
        if (location) {
            setValue('latitude', parseFloat(location.lat));
            setValue('longitude', parseFloat(location.lng));
        } else {
            setValue('latitude', undefined);
            setValue('longitude', undefined);
        }
    }

    const onHide = () => {
        props.hideDialog();
        reset({});
    }

    function onSubmit(data: any) {
        if (description === "" || description === null) {
            return props.toast.current?.show({ severity: 'error', detail: "Description field is required", life: 3000 });
        } else {
            saveToDB(data);
        }
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw', maxWidth: '400px' }} header="Add/Edit City" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVDropdown column={1} required label="Country" control={control} options={countries} optionLabel="name" optionValue="id" name="countryId" placeholder="Select Country" error={errors.countryId?.message} />
                <JVDropdown column={1} required label="State" control={control} options={states} optionLabel="name" optionValue="id" name="stateId" placeholder="Select State" error={errors.stateId?.message} />
                <JVInput column={1} required label="City Name" control={control} name="name" error={errors.name?.message} />
                <LocationAutocomplete col="12" label={`City Geographic Coordinates (Lat: ${lat ?? ""} | Lng: ${lng ?? ""})`} onLocationSelect={onLocationSelect} countryCode="in" />
                <JVInput column={1} label="Base Price" control={control} name="basePrice" />

                <JVCheckbox column={1} label="IsTouristDestination" control={control} name="isTouristDestination" />
                <JVCheckbox column={1} label="IsDisplayHome" control={control} name="isDisplayHome" />
                <div className="flex flex-column w-12 ml-2">
                    <label htmlFor="">Description:<span style={{ color: 'red' }}>*</span></label>
                    <CKEditor editor={ClassicEditor} data={description} onChange={(event, editor) => { setDescription(editor.getData()); }} />
                </div>
                <div className="col-12 md:col-12 flex gap-4 justify-content-end mt-4">
                    <Button style={{ width: '100px' }} loading={submitting} label="SAVE" type="submit" className="p-button-rounded"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-rounded p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}